const APP_SCHEME = "denker-app";
const LOCAL_DEV_SCHEME = "denker-local-dev-app";
// Production's web hosts. Their links name no server: Production apps
// installed before the release channel reject any parameter they do not
// know, and the app takes a link without one as its own channel's.
const PRODUCTION_HOSTS = new Set([
  "denker.ai",
  "www.denker.ai",
  "space.denker.ai",
]);

interface PageLocation {
  hostname: string;
  origin: string;
}

function currentLocation(): PageLocation {
  if (typeof window === "undefined") return { hostname: "", origin: "" };
  return window.location;
}

export function getDesktopDeepLinkScheme(
  hostname = currentLocation().hostname,
): string {
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "::1"
  ) {
    return LOCAL_DEV_SCHEME;
  }
  return APP_SCHEME;
}

/** The server a link into the desktop app names in `origin`, so one app can
 *  tell a Preview link from a Production one; null on Production. */
export function getDesktopLinkOrigin(
  location: PageLocation = currentLocation(),
): string | null {
  return PRODUCTION_HOSTS.has(location.hostname) ? null : location.origin;
}

export function getDesktopDeepLinkUrl(
  path = "auth",
  params?: Record<string, string | null | undefined>,
  location: PageLocation = currentLocation(),
): string {
  const cleanPath = path.replace(/^\/+/, "");
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params ?? {})) {
    if (value != null && key !== "origin") query.set(key, value);
  }
  const origin = getDesktopLinkOrigin(location);
  if (origin !== null) query.set("origin", origin);
  const search = query.toString();
  return `${getDesktopDeepLinkScheme(location.hostname)}://${cleanPath}${search ? `?${search}` : ""}`;
}
